export var BRAINTREE = "braintree";
export var WEX = "wex";
export var FLEETCOR = "fleetcor";
export var AFFIRM = "affirm";
export var BRAINTREE_ACH = "braintree (ACH)";
export var CREDIT_CARD = 'Credit Card';
export var ACH = 'ACH';
export var PAYPAL = 'PayPal';
export var CREDIT_CARD_TYPE = 'credit_card';
export var ACH_TYPE = 'ach';
export var PAY_PAL_ACCOUNT = 'pay_pal_account';